import { Component } from '@angular/core';
import { CustomListQueryBuilderService } from 'projects/alden-extension/src/lib/services/custom-list-query-builder.service';
import { Store } from '@ngrx/store';
import { AppStore } from '@alfresco/aca-shared/store';
import { ReloadCustomListTableAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';
import { CustomUserPreferencesService } from 'projects/alden-extension/src/lib/services/custom-user-preferences-service';

@Component({
  selector: 'smt-action-clear-filters',
  templateUrl: './clear-filters.component.html'
})
export class ClearFiltersComponent {

  constructor(
    private customListQueryBuilderService: CustomListQueryBuilderService,
    private customUserPreferencesService : CustomUserPreferencesService,
    private store: Store<AppStore>,
  ) {}

  clearFilters() {
    //Clear Filters
    this.customListQueryBuilderService.clearAndSetDefaultFilterQueries();
    this.customUserPreferencesService.clearAppliedValues();
    this.store.dispatch(new ReloadCustomListTableAction(true));
  }
}
